/* Package JSON Import will be here */
import React from "react";
import { Icon, Table, Header, Segment, Pagination, Button, Confirm, Modal, Form } from 'semantic-ui-react';
import DateFnsUtils from "@date-io/date-fns";
/* Package JSON Import will be here */

/* Project Import will be here */
import Layout from "../../comman/Layout/Layout";
import { Constants } from '../../config/appConstants';
import './forcast.css';
import "../../comman/Layout/Layout.css";
import "../../assets/styles/styles.css";
import NoResultFound from "../sharedComponent/noResultFound";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import moment from 'moment';
/* Project Import will be here */

const ForecastComponent = props => {
    const myiconstyle = { color: "#f18f40", margin: "5px", cursor: "pointer" };
    return (

        <Layout>
            <Segment className="header-section">
                <Header as="h3">
                    <Icon name="mixcloud"></Icon>
                    <span> Forecast</span>
                </Header>
                <i aria-hidden="true"
                    onClick={() => { props.onOpenModel({ data: {} }); }}
                    style={myiconstyle} className="plus circle icon">
                </i>
            </Segment>
            <Table className="ui celled table">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell className="tableCell"></Table.HeaderCell>
                        <Table.HeaderCell className="text-left">
                            Forecast Date
                        </Table.HeaderCell>
                        {/*<Table.HeaderCell className="text-left">
                            Days
                        </Table.HeaderCell>*/}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {props.forecastPage.forecastDataList && props.forecastPage.forecastDataList.length > 0 ? props.forecastPage.forecastDataList.map(({ id, isPastDate, forecastDate, forecastDays }) => (
                        <Table.Row style={{ verticalAlign: 'baseline' }}>
                            <Table.Cell className="tableCell">
                                <div className="forcastIcon">
                                    <i aria-hidden="true" className="trash alternate outline icon"
                                        onClick={() => {
                                            props.deleteForecast({ id });
                                        }}
                                    />
                                    {!isPastDate &&
                                        <Icon className="myiconstyle" edit name='edit pencil'
                                            onClick={() => {
                                                props.onOpenModel({ forecastId: id });
                                            }}
                                        />}
                                </div>
                            </Table.Cell>
                            <Table.Cell>{moment(new Date(forecastDate)).format("MM/DD/yyyy")}</Table.Cell>
                            {/*<Table.Cell>{forecastDays}</Table.Cell>*/}
                        </Table.Row>
                    )) :
                        <Table.Row>
                            <Table.Cell colSpan='3'>
                                <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                            </Table.Cell>
                        </Table.Row>
                    }
                </Table.Body>
            </Table>

            <Modal closeIcon
                open={props.forecastPage.isOpenModel}
                closeOnDimmerClick={false}
                onClose={() => { props.onCloseModel(); }}
                size='tiny'
            >
                <Modal.Header>Add Forecast Date</Modal.Header>
                <Modal.Content scrolling>
                    <Form>
                        <Form.Group inline widths='equal'>
                            <Form.Field required>
                                <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                    <KeyboardDatePicker
                                        placeholder="MM/dd/yyyy"
                                        value={props.forecastPage && props.forecastPage.selectedValue ? props.forecastPage.selectedValue.forecastDate : ""}
                                        onChange={date => props.handleDateChange(date)}
                                        inputProps={{ readOnly: true }}
                                        format="MM/dd/yyyy"
                                        label="Forecast Date"
                                        disablePast={true}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        style={{ width: '100%' }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Form.Field>
                            {/*<Form.Field required>
                                <Form.Input
                                    label="Forecast Days"
                                    placeholder='Forecast Days'
                                    name="forecastDays"
                                    type='number'
                                    min={0}
                                    onChange={(e) => { utility.allowOnlyPositiveIntegerValue(e); props.handleForecastDaysChange(e, { name: 'forecastDays', value: e.target.value }) }}
                                    value={props.forecastPage && props.forecastPage.selectedValue ? props.forecastPage.selectedValue.forecastDays : ""}
                                />
                            </Form.Field>*/}
                        </Form.Group>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    {props.forecastPage.isEditForecast ?
                        <Button disabled={props.forecastPage.isSetButtonDisabled} type="submit" primary onClick={() => props.onSaveForecast(props.forecastPage.selectedValue.id)}> Update </Button> :
                        <Button disabled={props.forecastPage.isSetButtonDisabled} type="submit" primary onClick={() => props.onSaveForecast()}> Save </Button>
                    }
                    <Button secondary onClick={() => props.onCloseModel()} > Back </Button>
                </Modal.Actions>
            </Modal>
            <Confirm
                closeIcon
                open={props.forecastPage.isSetButtonConfirm}
                content="Are you sure? Do you want to delete this Forecast?"
                header='Confirmation'
                size="tiny"
                onCancel={() => { props.onCancelConfirm() }}
                onConfirm={() => { props.onDeleteForecast() }}
            />
            {props.forecastPage.forecastDataList && props.forecastPage.forecastDataList.length > 0 &&
                <Pagination floated="right"
                    activePage={props.forecastPage.pagination.activePage}
                    onPageChange={props.onPageChange}
                    ellipsisItem={null}
                    firstItem={null}
                    lastItem={null}
                    totalPages={props.forecastPage.pagination.totalCount} />
            }
        </Layout >
    );
}

export default ForecastComponent;

ForecastComponent.displayName = "ForecastComponent";